import { Capacitor } from '@capacitor/core'
import { drawerStore } from '@eventr/common-storybook'
import { useSignalEffect } from '@preact/signals-react'
import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGuestStore } from '../feat/guest/guest.store'
import { loadPushToken } from '../feat/push/pushProvider'
import { bs, useBoundStore } from '../state/bound.store'
import { homeTabSignal } from '../state/itineraryState/itinerarySignals'
import { SeePast } from './components/seePast'
import { getCalendarSyncPerm } from './components/summary/syncCalendarRow'
import { HasItinerariesInstrunctionsHome } from './homePageInstructions/hasItineraries'
import { NoItinerariesInstrunctionsHome } from './homePageInstructions/noItineraries'

export const HomeScreen = () => {
    const { noItineraries, past, itineraryComponents } = useBoundStore(
        useShallow((s) => {
            return {
                noItineraries: s.noItineraries,
                past: s.past,
                itineraryComponents: s.itineraryComponents,
            }
        })
    )

    const isGuestMode = useGuestStore((s) => s.isGuestMode)

    useEffect(() => {
        bs().setOverride(null)
        drawerStore().closeDrawer()
        bs().setPast(false)
    }, [])

    //TODO: find better place to put this as it gets triggered multiple times
    useSignalEffect(() => {
        if (!Capacitor.isNativePlatform()) getCalendarSyncPerm()
        if (!isGuestMode) loadPushToken()
    })

    /**
     * Display the "See past" button if:
     * - Not in the past view
     * - There are itinerary components
     * - There are past itrinerary components
     * - The selected tab is not the map view
     */
    const displaySeePast =
        !past &&
        ['itinerary', 'summary'].includes(homeTabSignal.value) &&
        itineraryComponents &&
        Object.keys(itineraryComponents.past || {}).length !== 0

    return (
        <>
            <div style={{ height: '100%' }}>
                {/* This event swiper is hidden, with opacity of zero. It acts
                    as a spacer for the scrolling to have the correct top
                    offset. */}

                {!noItineraries ? (
                    <HasItinerariesInstrunctionsHome />
                ) : (
                    <NoItinerariesInstrunctionsHome />
                )}

                {displaySeePast && <SeePast />}
            </div>
        </>
    )
}
